import getTranslate from '@/mixins/getTranslate'

import { CategoriesGQL } from '@/graphql/queries'

function mapReqCountry (reqCountry) {
  return {
    id: reqCountry.id,
    name: reqCountry.name,
    code: reqCountry.code,
    currency: reqCountry.currency
  }
}

function mapDocument (document) {
  return {
    fileName: document.origin,
    documentCode: document.key,
    file: document.path
  }
}

export default {
  apollo: {
    categories: {
      query: CategoriesGQL,
      update: data => data.commonData.Categories,
      skip () { return this.skipFetchCommonData }
    }
  },

  mixins: [getTranslate],

  computed: {
    skipFetchCommonData () {
      return typeof this.computedShow !== 'undefined' && this.computedShow === false
    }
  },

  methods: {
    serializeFields (incomeFields) {
      const fields = Object.assign({}, incomeFields)

      if (typeof fields.contractList !== 'undefined') {
        delete fields.contractList
      }

      if (fields.documentList && Array.isArray(fields.documentList)) {
        fields.documentList = fields.documentList.map(doc => {
          return {
            path: doc.file,
            name: doc.fileName,
            origin: doc.fileName,
            size: 0,
            contentType: '',
            ...doc
          }
        })

        if (fields.shopList && Array.isArray(fields.shopList)) {
          fields.shopList = fields.shopList.map((field) => {
            if (field.workingHoursList && Array.isArray(field.workingHoursList)) {
              field.workingHoursList = field.workingHoursList.map(doc => {
                return {
                  ...doc,
                  date: doc.date !== null ? new Date(doc.date).toISOString() : null
                }
              })
            }
            return field
          })
        }

        fields.MM_LOGO = fields.documentList.find(d => d.documentCode === 'MM_LOGO' && d.file !== null) || null
        fields.MM_BIG_PHOTO = fields.documentList.find(d => d.documentCode === 'MM_BIG_PHOTO' && d.file !== null) || null
        fields.CHECK_EXAMPLE_1 = fields.documentList.find(d => d.documentCode === 'CHECK_EXAMPLE_1' && d.file !== null) || null
        fields.CHECK_EXAMPLE_2 = fields.documentList.find(d => d.documentCode === 'CHECK_EXAMPLE_2' && d.file !== null) || null
        fields.CHECK_EXAMPLE_3 = fields.documentList.find(d => d.documentCode === 'CHECK_EXAMPLE_3' && d.file !== null) || null
        fields.CHECK_EXAMPLE_4 = fields.documentList.find(d => d.documentCode === 'CHECK_EXAMPLE_4' && d.file !== null) || null
        fields.CHECK_EXAMPLE_5 = fields.documentList.find(d => d.documentCode === 'CHECK_EXAMPLE_5' && d.file !== null) || null
        fields.IP_SVIDETELSTVO_O_REGISTRACII = fields.documentList.find(d => d.documentCode === 'IP_SVIDETELSTVO_O_REGISTRACII' && d.file !== null) || null
        fields.IP_SVIDETELSTVO_O_REGISTRACII_NALOG = fields.documentList.find(d => d.documentCode === 'IP_SVIDETELSTVO_O_REGISTRACII_NALOG' && d.file !== null) || null
        fields.OOO_USTAV = fields.documentList.find(d => d.documentCode === 'OOO_USTAV' && d.file !== null) || null
        fields.OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY = fields.documentList.find(d => d.documentCode === 'OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY' && d.file !== null) || null
        fields.OOO_DOVERENNOST_NA_PODPIS = fields.documentList.find(d => d.documentCode === 'OOO_DOVERENNOST_NA_PODPIS' && d.file !== null) || null
        fields.OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG = fields.documentList.find(d => d.documentCode === 'OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG' && d.file !== null) || null
        fields.OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL = fields.documentList.find(d => d.documentCode === 'OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL' && d.file !== null) || null
        fields.TAXPAYER_IDENTITY_CARD = fields.documentList.find(d => d.documentCode === 'TAXPAYER_IDENTITY_CARD' && d.file !== null) || null
      }

      delete fields.documentList

      return fields
    },

    mapFields (incomeFields) {
      const fields = Object.assign({}, incomeFields)
      fields.reqCountry = mapReqCountry(fields.reqCountry)
      delete fields.rulesAccept
      fields.reqCompanyRegistrationDate = new Date(fields.reqCompanyRegistrationDate).toUTCString()
      fields.orderCategory = fields.orderCategory ? this.categories.find(cat => cat.id === fields.orderCategory.id) : fields.orderCategory
      delete fields.rewardType

      if (typeof fields.draft !== 'undefined') {
        delete fields.draft
      }

      if (fields.cashBackPeriod === '') {
        fields.cashBackPeriod = null
      } else if (typeof fields.draft !== 'string') {
        fields.cashBackPeriod = parseInt(fields.cashBackPeriod)
      }

      if (typeof fields.contractList !== 'undefined') {
        delete fields.contractList
      }

      fields.countryList = fields.countryList.map(f => {
        delete f.__typename
        return f
      })

      fields.cityList = fields.cityList.map(f => {
        delete f.__typename
        if (f.country) {
          delete f.country.__typename
        }
        return f
      })

      if (fields.orderCategory) {
        delete fields.orderCategory.__typename
        fields.orderCategory.translationList = fields.orderCategory.translationList.map(t => {
          delete t.__typename
          return t
        })
      }

      const documentList = []
      if (fields.MM_LOGO) {
        documentList.push(
          mapDocument({
            key: 'MM_LOGO',
            documentCode: 'MM_LOGO',
            ...fields.MM_LOGO
          })
        )
      }

      if (fields.MM_BIG_PHOTO) {
        documentList.push(
          mapDocument({
            key: 'MM_BIG_PHOTO',
            documentCode: 'MM_BIG_PHOTO',
            ...fields.MM_BIG_PHOTO
          })
        )
      }
      if (fields.CHECK_EXAMPLE_1 && fields.offline) {
        documentList.push(
          mapDocument({
            key: 'CHECK_EXAMPLE_1',
            documentCode: 'CHECK_EXAMPLE_1',
            ...fields.CHECK_EXAMPLE_1
          })
        )
      }
      if (fields.CHECK_EXAMPLE_2 && fields.offline) {
        documentList.push(
          mapDocument({
            key: 'CHECK_EXAMPLE_2',
            documentCode: 'CHECK_EXAMPLE_2',
            ...fields.CHECK_EXAMPLE_2
          })
        )
      }
      if (fields.CHECK_EXAMPLE_3 && fields.offline) {
        documentList.push(
          mapDocument({
            key: 'CHECK_EXAMPLE_3',
            documentCode: 'CHECK_EXAMPLE_3',
            ...fields.CHECK_EXAMPLE_3
          })
        )
      }
      if (fields.CHECK_EXAMPLE_4 && fields.offline) {
        documentList.push(
          mapDocument({
            key: 'CHECK_EXAMPLE_4',
            documentCode: 'CHECK_EXAMPLE_4',
            ...fields.CHECK_EXAMPLE_4
          })
        )
      }
      if (fields.CHECK_EXAMPLE_5 && fields.offline) {
        documentList.push(
          mapDocument({
            key: 'CHECK_EXAMPLE_5',
            documentCode: 'CHECK_EXAMPLE_5',
            ...fields.CHECK_EXAMPLE_5
          })
        )
      }
      if (fields.IP_SVIDETELSTVO_O_REGISTRACII) {
        documentList.push(
          mapDocument({
            key: 'IP_SVIDETELSTVO_O_REGISTRACII',
            documentCode: 'IP_SVIDETELSTVO_O_REGISTRACII',
            ...fields.IP_SVIDETELSTVO_O_REGISTRACII
          })
        )
      }
      if (fields.IP_SVIDETELSTVO_O_REGISTRACII_NALOG) {
        documentList.push(
          mapDocument({
            key: 'IP_SVIDETELSTVO_O_REGISTRACII_NALOG',
            documentCode: 'IP_SVIDETELSTVO_O_REGISTRACII_NALOG',
            ...fields.IP_SVIDETELSTVO_O_REGISTRACII_NALOG
          })
        )
      }
      if (fields.OOO_USTAV) {
        documentList.push(
          mapDocument({
            key: 'OOO_USTAV',
            documentCode: 'OOO_USTAV',
            ...fields.OOO_USTAV
          })
        )
      }

      if (fields.OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY) {
        documentList.push(
          mapDocument({
            key: 'OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY',
            documentCode: 'OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY',
            ...fields.OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY
          })
        )
      }
      if (fields.OOO_DOVERENNOST_NA_PODPIS) {
        documentList.push(
          mapDocument({
            key: 'OOO_DOVERENNOST_NA_PODPIS',
            documentCode: 'OOO_DOVERENNOST_NA_PODPIS',
            ...fields.OOO_DOVERENNOST_NA_PODPIS
          })
        )
      }
      if (fields.OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG) {
        documentList.push(
          mapDocument({
            key: 'OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG',
            documentCode: 'OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG',
            ...fields.OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG
          })
        )
      }
      if (fields.OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL) {
        documentList.push(
          mapDocument({
            key: 'OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL',
            documentCode: 'OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL',
            ...fields.OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL
          })
        )
      }
      if (fields.TAXPAYER_IDENTITY_CARD) {
        documentList.push(
          mapDocument({
            key: 'TAXPAYER_IDENTITY_CARD',
            documentCode: 'TAXPAYER_IDENTITY_CARD',
            ...fields.TAXPAYER_IDENTITY_CARD
          })
        )
      }
      fields.documentList = documentList

      delete fields.MM_LOGO
      delete fields.MM_BIG_PHOTO
      delete fields.CHECK_EXAMPLE_1
      delete fields.CHECK_EXAMPLE_2
      delete fields.CHECK_EXAMPLE_3
      delete fields.CHECK_EXAMPLE_4
      delete fields.CHECK_EXAMPLE_5
      delete fields.IP_SVIDETELSTVO_O_REGISTRACII
      delete fields.IP_SVIDETELSTVO_O_REGISTRACII_NALOG
      delete fields.OOO_USTAV
      delete fields.OOO_PRIKAZ_O_NAZNACHENII_RUKOVODITELEY
      delete fields.OOO_DOVERENNOST_NA_PODPIS
      delete fields.OOO_SVIDETELSTVO_O_POSTANOVKE_NA_UCHET_NALOG
      delete fields.OOO_SVIDETELSTVO_O_GOS_REGISTRASII_UL
      delete fields.TAXPAYER_IDENTITY_CARD

      delete fields.loginApprove

      if (fields.shopList && fields.shopList.length) {
        fields.shopList = fields.shopList.map(s => {
          delete s.__typename
          if (s.contactList && s.contactList.length) {
            s.contactList = s.contactList.map(c => {
              delete c.__typename
              return c
            })
          }

          if (s.workingHoursList && s.workingHoursList.length) {
            s.workingHoursList = s.workingHoursList.map(w => {
              delete w.__typename
              return w
            })
          }
          return s
        })

        fields.shopList = fields.shopList.filter(shop => {
          return shop.name !== null && shop.address !== null && shop.lat !== null && shop.lng !== null
        })
      }

      if (!fields.offline) {
        fields.shopList = []
      }

      delete fields.documentsAccept
      delete fields.documentType
      delete fields.__typename

      return fields
    }
  }
}
